import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    Button
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object({
    categoryName: Yup.string().required('Category Name is required'),
    categoryCode: Yup.number()
        .typeError('Category Code must be a number')
        .test(
            'max-digits',
            'Category Code should be at most 8 digits',
            (value) => value !== null && value !== undefined && String(Math.floor(Math.abs(value))).length <= 8
        )
        .required('Category Code is required')
});

const CategoryDialog = ({ open, onClose, selectedCategory, onSubmit }) => {
    const formik = useFormik({
        initialValues: {
            categoryName: selectedCategory ? selectedCategory.categoryName : '',
            categoryCode: selectedCategory ? selectedCategory.categoryCode : ''
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await onSubmit(values);
        }
    });

    const handleDialogClose = () => {
        formik.resetForm();
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleDialogClose}>
            <DialogTitle>{selectedCategory ? 'Edit Category' : 'Add New Category'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {selectedCategory
                        ? 'Update category name and category code here. Category code can be 8 characters long only.'
                        : 'Enter category name and category code here. Category code can be 8 characters long only.'}
                </DialogContentText>
                <form onSubmit={formik.handleSubmit}>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="categoryName"
                        name="categoryName"
                        label="Enter category name here"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                            const trimmedValue = e.target.value.replace(/^\s+/, '');
                            formik.handleChange(e);
                            formik.setFieldValue('categoryName', trimmedValue);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.categoryName}
                        error={formik.touched.categoryName && Boolean(formik.errors.categoryName)}
                        helperText={formik.touched.categoryName && formik.errors.categoryName}
                    />
                    <TextField
                        margin="dense"
                        id="categoryCode"
                        name="categoryCode"
                        label="Enter category code"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                            const trimmedValue = e.target.value.replace(/^\s+/, '');
                            formik.handleChange(e);
                            formik.setFieldValue('categoryCode', trimmedValue);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.categoryCode}
                        error={formik.touched.categoryCode && Boolean(formik.errors.categoryCode)}
                        helperText={formik.touched.categoryCode && formik.errors.categoryCode}
                    />
                    <DialogActions>
                        <Button onClick={handleDialogClose}>Cancel</Button>
                        <Button
                            type="submit"
                            disabled={!formik.isValid || formik.isSubmitting}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default CategoryDialog;
